module.exports = __webpack_public_path__ + "37ba7b92/img/delete-icon.eb7de062.svg";